import React from "react";
import { Badge } from "@mantine/core";

interface SignStatusBadgeProps {
  status: "PENDING" | "APPROVED" | "REJECTED";
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}

export const SignStatusBadge: React.FC<SignStatusBadgeProps> = ({
  status,
  size = "md",
}) => {
  const getColor = () => {
    switch (status) {
      case "PENDING":
        return "yellow";
      case "APPROVED":
        return "green";
      case "REJECTED":
        return "red";
      default:
        return "gray";
    }
  };

  const getText = () => {
    switch (status) {
      case "PENDING":
        return "Pending";
      case "APPROVED":
        return "Approved";
      case "REJECTED":
        return "Rejected";
      default:
        return "Unknown";
    }
  };

  return (
    <Badge color={getColor()} size={size} variant="light">
      {getText()}
    </Badge>
  );
};
